import { useReveal } from "@/hooks/useReveal";

const COUNTRIES = [
  { name: "Germany", line: "organic retail and distribution" },
  { name: "Australia", line: "traceability and social-impact buyers" },
  {
    name: "Chile",
    line: "full private label range developed for a distributor",
  },
  { name: "Romania", line: "organic distribution" },
];

export default function WhereWeShip() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-cream py-16 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold text-center">
            Where we already ship
          </h2>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {COUNTRIES.map((c) => (
              <div
                key={c.name}
                className="bg-white rounded-lg p-6 border border-cream-dark/60"
              >
                <h3 className="text-ink font-serif text-lg font-semibold">
                  {c.name}
                </h3>
                <p className="mt-2 text-ink/70 text-[17px] leading-relaxed">
                  {c.line}
                </p>
              </div>
            ))}
          </div>

          <p className="mt-6 text-center text-ink/60 text-sm">
            References available on request.
          </p>
        </div>
      </div>
    </section>
  );
}